import { compose, mdsWidget } from 'dojo/_base/declare';

import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import lang from 'dojo/_base/lang';
import TempInvoiceView from './TempInvoiceProjectView';
import { TempInvoiceFinderProject, TempInvoicePresetData } from "./TempInvoiceTypes";

class TempInvoiceFinder extends compose(FinderBaseV2) {

    private _onClickRow(row: StaticTable.StaticTableRow<TempInvoiceFinderProject>) {
        let entity = row.rowGroup.entity;

        let view = new TempInvoiceView();
        view.setup(entity.ID, entity.$Displayname, entity, null, "tempInvoice", this.getTabContainerName());
        view.on("saved", lang.hitch(this, this._onViewSaved, entity));
    }

    private _onViewSaved(entity: TempInvoiceFinderProject) {
        let view = new TempInvoiceView();
        view.setup(entity.ID, entity.$Displayname, entity, null, "tempInvoice", this.getTabContainerName());
        view.on("saved", lang.hitch(this, this._onViewSaved, entity));
    }



    private _tableFormatter(cell: StaticTable.StaticTableCell<TempInvoiceFinderProject>) {
        return false;
    }  

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API__TempInvoiceFinder_GetConfig",
            "Webtool_API__TempInvoiceFinder_GetResults",
            lang.hitch(this, this._onClickRow),
            lang.hitch(this, this._tableFormatter),
        );
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TempInvoiceFinder);